import React from 'react';
import { SettingsManagement } from '../features/settings';

/**
 * SettingsPage - Admin system settings page
 */
export const SettingsPage: React.FC = () => {
  return <SettingsManagement />;
};

export default SettingsPage;
